import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";

type Props = {
  /**
   * A string representing the source URL.
   */
  srcUrl: string;
};

export const HeaderUI = ({ srcUrl }: Props) => {
  return (
    <div data-testid="header" className="esi-wrapper">
      <ESIInclude src={srcUrl} id="header" />
    </div>
  );
};
